import styled, { css } from 'styled-components';

const colorCss = css`
  background-color: ${({ theme }) => theme.colors.gray300};
  border-radius: 4px;
`;

export const S = {
  Warpper: styled.div`
    display: flex;
    width: 100%;

    ${({ theme }) => theme.media.mobile} {
      flex-direction: column;
      align-items: center;
    }
  `,
  Logo: styled.div`
    margin-top: 30px;
    width: 80px;
    height: 80px;

    ${colorCss};

    ${({ theme }) => theme.media.mobile} {
      width: 48px;
      height: 48px;
    }
  `,
  Info: styled.div`
    width: 240px;
    height: 16px;

    ${colorCss};
  `,
  Name: styled.div`
    width: 120px;
    height: 24px;

    ${colorCss};
  `,
  Content: styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 8px;
    margin-left: 30px;

    ${({ theme }) => theme.media.mobile} {
      align-items: center;
      margin: 0;
      margin-top: 12px;
    }
  `,
  ButtonGroup: styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    margin-left: auto;

    button {
      padding: 9px 30px;
      gap: 4px;

      width: 120px;
      height: 40px;
      ${colorCss};
      border-radius: 20px;
    }

    ${({ theme }) => theme.media.mobile} {
      margin: 0;
      margin-top: 50px;
      margin-bottom: 30px;
    }
  `,
};
